<template>
<div>

  <el-table  v-if="queryType === 'sply'"
    :data="tableData"
    style="width: 100%"
    :span-method="objectSpanMethod"
    height="400"
    >
    <!-- <el-table-column
      prop="name"
      label="区域"
      width="180">
    </el-table-column> -->
    <el-table-column prop="date" label="时间"></el-table-column>
    <el-table-column prop="asset" label="区域"></el-table-column>
    <el-table-column prop="now" :label="'今年此' + dateType + unit"></el-table-column>
    <el-table-column prop="past" :label="'去年此' + dateType + unit"></el-table-column>
    <!-- <el-table-column prop="unit" label="单位"></el-table-column> -->
    <el-table-column prop="rate" label="同比"></el-table-column>
  </el-table>
  <el-table  v-else-if="queryType === 'lp'"
    :data="tableData"
    :span-method="objectSpanMethod"
    style="width: 100%"
    height="400"
    >
    <!-- <el-table-column
      prop="name"
      label="区域"
      width="180">
    </el-table-column> -->
    <el-table-column prop="date" label="时间"></el-table-column>
    <el-table-column prop="asset" label="区域"></el-table-column>
    <el-table-column prop="now" :label="'本' + dateType + unit"></el-table-column>
    <el-table-column prop="past" :label="'上' + dateType + unit"></el-table-column>
    <!-- <el-table-column prop="unit" label="单位"></el-table-column> -->
    <el-table-column prop="rate" label="环比"></el-table-column>
  </el-table>

  <el-table ref="tableBody" v-if="queryType === 'sply'"
    class="hide-table"
    :data="tableData"
    style="width: 100%"
    height="380"
    >
    <!-- <el-table-column
      prop="name"
      label="区域"
      width="180">
    </el-table-column> -->
    <el-table-column prop="date" label="时间"></el-table-column>
    <el-table-column prop="asset" label="区域"></el-table-column>
    <el-table-column prop="now" :label="'今年此' + dateType + unit"></el-table-column>
    <el-table-column prop="past" :label="'去年此' + dateType + unit"></el-table-column>
    <el-table-column prop="rate" label="同比"></el-table-column>
  </el-table>
  <el-table ref="tableBody" v-else-if="queryType === 'lp'"
    class="hide-table"
    :data="tableData"
    style="width: 100%"
    height="380"
    >
    <!-- <el-table-column
      prop="name"
      label="区域"
      width="180">
    </el-table-column> -->
    <el-table-column prop="date" label="时间"></el-table-column>
    <el-table-column prop="asset" label="区域"></el-table-column>
    <el-table-column prop="now" :label="'本' + dateType + unit"></el-table-column>
    <el-table-column prop="past" :label="'上' + dateType + unit"></el-table-column>
    <el-table-column prop="rate" label="环比"></el-table-column>
  </el-table>

</div>
</template>

<script>
export default {
  name: 'QueryTable',
  props: ['queryData', 'deviceList', 'queryType', 'date', 'unit'],
  data() {
    return {}
  },
  methods: {
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % this.deviceList.length === 0) {
          return {
            rowspan: this.deviceList.length,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    }
  },
  computed: {
    tableData() {
      return this.queryData
    },
    dateType() {
      if (this.date[0]) {
        switch (this.date[0]) {
          case 'day':
            return '日'
          case 'month':
            return '月'
          case 'year':
            return '年 '
          default:
            return '月'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.hide-table {
//  display: none;
}
</style>
